import { Fragment } from "react/jsx-runtime";
import TabNavLayout from "../layouts/TestOrdersLayout";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import OrderSummaryScreen from "./OrderSummaryScreen";
import useProfile from "../services/utils/custom hooks/useProfile";
import useFeatureFlags from "../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import dataConstants from "../constants/dataConstants";
import { useEffect } from "react";

function TabNavRoutes() {
  const match = useRouteMatch();
  const { data } = useProfile();
  const roles = data?.user?.roles ?? [];
  const tabs: any = [
    {
      textInformation: {
        fontWeight: "font-normal",
        text: "Test orders",
      },
      to: "/access/test-orders",
      activeOnlyWhenExact: true,
      onClick: () => {},
      buttonTheme: "primary",
    },
    {
      textInformation: {
        fontWeight: "font-normal",
        text: "Referral Orders",
      },
      to: "/access/test-orders/referrals",
      activeOnlyWhenExact: true,
      onClick: () => {},
      buttonTheme: "primary",
    },
  ];
  return (
    <Switch>
      <Route
        path={`${match.path}/summary/:id`}
        component={OrderSummaryScreen}
      />
      <TabNavLayout
        tabs={tabs.filter((tab: any) => {
          if (roles.includes("Physician")) {
            return true;
          }
          return tab.textInformation.text !== "Referrals";
        })}
      />
    </Switch>
  );
}

export default function TestOrdersPageRoutes() {
  const match = useRouteMatch();
  const history = useHistory();
  const { data, isLoading } = useProfile();
  const { isSectionActive } = useFeatureFlags();
  const roles = data?.user?.roles ?? [];
  const tabs: any = [
    {
      textInformation: {
        fontWeight: "font-normal",
        text: "Test orders",
      },
      to: "/access/test-orders",
      activeOnlyWhenExact: true,
      onClick: () => {},
      buttonTheme: "primary",
    },
    {
      textInformation: {
        fontWeight: "font-normal",
        text: "Referral Orders",
      },
      to: "/access/test-orders/referrals",
      activeOnlyWhenExact: true,
      onClick: () => {},
      buttonTheme: "primary",
    },
  ];

  useEffect(() => {
    if (!isSectionActive(dataConstants.FeatureFlagSectionKeys.TEST_ORDERS)) {
      history.push("/unauthorized");
    }
  }, [isLoading]);

  return (
    <Switch>
      <Route path={match.path} component={TabNavRoutes} />
    </Switch>
  );
}
